import './EnergyEfficiencyLabel.scss';
import { EnergyEfficiencyClass } from '@belimo-retrofit-portal/logic';
import clsx from 'clsx';
import React, { useState } from 'react';

type Props = {
  readonly value: EnergyEfficiencyClass | null;
  readonly size?: 'md' | 'sm';
  readonly disabled?: boolean;
  readonly fixed?: boolean;
  readonly children: React.ReactNode;
};

export const EnergyEfficiencyLabel = ({ value, size = 'md', fixed, disabled, children }: Props): React.ReactElement => {
  const [labelWidth, setLabelWidth] = useState(0);

  return (
    <div className={clsx({
      'bp-energy-efficiency-label': true,
      'bp-energy-efficiency-label--fixed': fixed,
      [`bp-energy-efficiency-label--${value || 'unknown'}`]: true,
      'bp-energy-efficiency-label--disabled': disabled,
    })}
    >
      <div
        ref={(current) => setLabelWidth(current?.offsetWidth || 0)}
        className={
          clsx({
            'bp-energy-efficiency-label__label': true,
            'bp-energy-efficiency-label__label--fixed': fixed,
            [`bp-energy-efficiency-label__label--${value || 'unknown'}`]: true,
            [`bp-energy-efficiency-label__label--${size}`]: true,
          })
        }
        style={{ clipPath: `polygon(0 0, ${labelWidth - 7}px 0, 100% 50%, ${labelWidth - 7}px 100%, 0 100%)` }}
      >
        <div className={clsx({
          'bp-energy-efficiency-label__value': true,
          [`bp-energy-efficiency-label__value--${size}`]: true,
          'bp-energy-efficiency-label__value--disabled': disabled,
        })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
